import React from "react";
import cs from "classnames";
import { components } from "react-select";

export const CustomNoOptionsMessage = (props: any) => {
  const { selectProps } = props;
  const inputValue = selectProps.inputValue || "";

  return (
    <components.NoOptionsMessage {...props}>
      <div
        className={cs("SearchingDirectory", {
          SearchingDirectory__hide: props.hideMessage,
        })}
      >
        {inputValue.length <= 1
          ? "Start typing to search for people"
          : "No result found"}
      </div>
    </components.NoOptionsMessage>
  );
};
